// extracted by mini-css-extract-plugin
export default {"pie_chart":"PieChart_pie_chart__NeK8G","no_chart":"PieChart_no_chart__3kySv"};